export type EntitlementProfile = {
  subscription_status?: string | null;
  affiliate_comp_pro_until?: string | null;
};

export type Entitlement = {
  isSubscribed: boolean;
  isTrialing: boolean;
  isCompPro: boolean;
};

export function hasPaidSubscriptionStatus(
  status: string | null | undefined,
): boolean {
  return status === "active" || status === "trialing";
}

export function hasUnexpiredCompPro(
  until: string | null | undefined,
  now = new Date(),
): boolean {
  if (!until) {
    return false;
  }
  const expiresAt = Date.parse(until);
  if (Number.isNaN(expiresAt)) {
    return false;
  }
  return expiresAt > now.getTime();
}

export function resolveEntitlement(
  profile: EntitlementProfile | null | undefined,
  now = new Date(),
): Entitlement {
  const isPaid = hasPaidSubscriptionStatus(profile?.subscription_status);
  const isCompPro =
    !isPaid && hasUnexpiredCompPro(profile?.affiliate_comp_pro_until, now);
  return {
    isSubscribed: isPaid || isCompPro,
    isTrialing: profile?.subscription_status === "trialing",
    isCompPro,
  };
}
